<div class="flex flex-col items-center sm:items-start xl:items-end">
  <div class="size-64">
    <app-external-link
      [underline]="false"
      link="https://poland.payu.com/rozwiazania-platnicze/payu-raty/payu-raty-dla-kupujacych/">
      <app-image-thumbnail size="full">
        <img
          [fill]="true"
          [ngSrc]="AssetImage.PayUInstallments | assetImageUrl"
          alt="Zdjęcie PayU raty." />
      </app-image-thumbnail>
    </app-external-link>
  </div>

  <div>
    <div class="mb-3 text-center font-bold uppercase sm:text-left">
      Sklep obsługiwany przez:
    </div>

    <div class="flex flex-col items-center gap-2 sm:items-start xl:items-end">
      <div class="w-64">
        <div class="aspect-[403/34]">
          <app-image-thumbnail size="full">
            <img
              [fill]="true"
              [ngSrc]="AssetImage.PaymentSystem | assetImageUrl"
              alt="Zdjęcie metod płatności." />
          </app-image-thumbnail>
        </div>
      </div>

      <div class="w-32">
        <div class="aspect-[81/25]">
          <app-image-thumbnail size="full">
            <img
              [fill]="true"
              [ngSrc]="AssetImage.MasterCardAndVisa | assetImageUrl"
              alt="Zdjęcie Master Card oraz Visa." />
          </app-image-thumbnail>
        </div>
      </div>
    </div>
  </div>
</div>
